import store from "../../../store";
import { ReceptionDetailStatusSearchCondition, ReceptionSearchActiveKinds } from ".";
import { WorkflowStatusName, ReceptionReportType } from "../items";
import { ReceptionDateKinds, ReceptionDateKindsName } from "../kinds";

import { Patient } from "../../patient";
import { DateDuration } from "../../system";
import { Department } from "../../department";
import { ReceptionDateTranslator } from "../ReceptionDateTranslator";
import { IConfiguration } from "../../../domain/configuration";

// TODO検索条件
export class ReceptionTodoSearchCondition {
  dateKind: ReceptionDateKinds;
  duration: DateDuration;

  paperStatus: ReceptionSearchActiveKinds;
  reportType: ReceptionReportType;
  patient: Patient;
  generalFlag1Status: ReceptionSearchActiveKinds;
  department: Department;
  statuses: ReceptionDetailStatusSearchCondition;
  workflowStatus: WorkflowStatusName;

  isParamPatientSearch: boolean; // 患者指定でWF起動されたときにtrueになる（初回のみ）

  private _dateTranslator: ReceptionDateTranslator;

  constructor() {
    this.duration = new DateDuration(null, null);
    this.statuses = new ReceptionDetailStatusSearchCondition();
    this.workflowStatus = null;
    this.paperStatus = ReceptionSearchActiveKinds.NotSpecificated;
    this.reportType = null;
    this.generalFlag1Status = ReceptionSearchActiveKinds.NotSpecificated;
    this._dateTranslator = new ReceptionDateTranslator();
  }

  getSummary(generalFlag1Name: string): string {
    const config = store.getters.configuration as IConfiguration;
    let summary = "";
    summary = this.toDurationString(this.dateKind, this.duration) + 
      this.toItemString("進捗", this.workflowStatus ? this.workflowStatus.name : "全進捗（進行中）") +
      (this.paperStatus !== ReceptionSearchActiveKinds.NotSpecificated
        ? "手書き" + (this.paperStatus === ReceptionSearchActiveKinds.Inactivated ? "なし " : " ")
        : "") + 
      (this.reportType ? this.toItemString(config.wording.format.attributes.name + "種別", this.reportType.name) : "") + 
      (this.patient ? this.toItemString("患者番号", this.patient.id) : "") +
      (this.department ? this.toItemString(config.wording.common.department, this.department.name) : "") +
      (this.generalFlag1Status !== ReceptionSearchActiveKinds.NotSpecificated
        ? generalFlag1Name + (this.generalFlag1Status === ReceptionSearchActiveKinds.Activated ? " " : "なし ")
        : "") +
      this.toItemString("ステータス", this.statuses.getSummary());
  
    return summary;
  }

  private toDurationString(kind: ReceptionDateKinds, value: DateDuration): string {
    if (value && (value.from || value.to)) {
      return ReceptionDateKindsName.getDisplayName(kind) + "：" + this._dateTranslator.toDateDispString(value.from) + "～" + this._dateTranslator.toDateDispString(value.to) + " ";
    } 
    return "";
  }

  private toItemString(itemLabel: string, value: string): string {
    if (value.length === 0) { return ""; }
    return itemLabel + "：" + value + " ";
  }

  /**
   * ToDo画面は公開のチェックなしの絞り込みまでは対応しない
   * false: 絞り込みの条件にしない
   * true: チェックが入っているものだけに絞り込み
   */
  get generalFlag1(): boolean {
    return this.generalFlag1Status === ReceptionSearchActiveKinds.Activated;
  }

  set generalFlag1(value: boolean) {
    this.generalFlag1Status = value
      ? ReceptionSearchActiveKinds.Activated
      : ReceptionSearchActiveKinds.NotSpecificated;
  }

  /**
   * false: 手書き以外の依頼だけに絞り込み
   * true: 絞り込みの条件にしない
   */
  get isPaperIncluded(): boolean {
    return this.paperStatus === ReceptionSearchActiveKinds.NotSpecificated;
  }

  set isPaperIncluded(value: boolean) {
    this.paperStatus = value
      ? ReceptionSearchActiveKinds.NotSpecificated
      : ReceptionSearchActiveKinds.Inactivated;
  }

  clone(): ReceptionTodoSearchCondition {
    const newObj = new ReceptionTodoSearchCondition();
    newObj.dateKind = this.dateKind;
    newObj.duration = this.duration;
    newObj.paperStatus = this.paperStatus;
    newObj.reportType = this.reportType;
    newObj.patient = this.patient;
    newObj.generalFlag1Status = this.generalFlag1Status;
    newObj.department = this.department;
    newObj.statuses = this.statuses.clone();
    newObj.workflowStatus = this.workflowStatus ? this.workflowStatus.clone() : null;
    newObj.isParamPatientSearch = this.isParamPatientSearch;

    return newObj;
  }
}
